export const agreementDefaultFields = ["interval_id", "notice_months", "duration_years", "agreement_text", "conditions"];

export function applyAgreementTypeDefaults(values, type, owned = {}, enabled = true) {
  const defaults = {
    interval_id: type?.default_interval_id ?? null,
    notice_months: type?.default_notice_months ?? null,
    duration_years: type?.default_duration_years ?? null,
    agreement_text: type?.default_agreement_text ?? "",
    conditions: type?.conditions ?? "",
  };
  const next = { ...values };
  agreementDefaultFields.forEach((field) => {
    if (!owned[field]) next[field] = enabled ? defaults[field] : (field === "conditions" || field === "agreement_text" ? "" : null);
  });
  return next;
}
